module.exports = __webpack_public_path__ + "7c7d358b8bc93a97f40c87fff985b296.fbx";